var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotifyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2783 16H18.8641C19.6452 16 20.2783 15.3668 20.2783 14.5858C20.2783 14.2107 20.1293 13.851 19.8641 13.5858L18.8641 12.5858C18.489 12.2107 18.2783 11.702 18.2783 11.1716L18.2783 7.97067C18.2783 3.56859 14.7097 0 10.3076 0C5.89621 0 2.32375 3.58319 2.33699 7.9946L2.34646 11.1476C2.34809 11.6922 2.1276 12.2139 1.73591 12.5922L0.706956 13.586C0.433026 13.8506 0.278322 14.2151 0.27832 14.5959C0.27832 15.3714 0.906948 16 1.6824 16H6.27832C6.27832 18.2091 8.06918 20 10.2783 20C12.4875 20 14.2783 18.2091 14.2783 16ZM17.8034 13.6464L18.657 14.5H1.91979L2.77799 13.6711C3.46345 13.009 3.84931 12.0961 3.84645 11.1431L3.83699 7.9901C3.82624 4.40887 6.72639 1.5 10.3076 1.5C13.8813 1.5 16.7783 4.39702 16.7783 7.97067L16.7783 11.1716C16.7783 12.0998 17.1471 12.9901 17.8034 13.6464ZM12.7783 16H7.77832C7.77832 17.3807 8.89761 18.5 10.2783 18.5C11.659 18.5 12.7783 17.3807 12.7783 16Z",
    fill: "#3D3839"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifyIcon);
export default __webpack_public_path__ + "static/media/notify_icon.b9c8371e4d169ca5b572367a3bf91b60.svg";
export { ForwardRef as ReactComponent };